import { buildDottedNestedRowPredicate, coerceLeafValueToSchemaType, coerceUntypedValue, resolveLeafSchema } from "@scalar/workspace-store/request-example";
import { setValueAtPath } from "@scalar/helpers/object/set-value-at-path";
//#region src/v2/blocks/request-block/helpers/fold-structured-body-rows.ts
/**
* Fold form-table rows back into the structured body object.
*
* Inverse of `getStructuredBodyRows`: dotted names fold into nested objects only when
* the schema declares the top segment as a nested object (same predicate the multipart
* builder uses), so a user-typed literal key like `user.email` on an undeclared prefix
* stays flat. Values come back from the table as strings and are restored to their
* schema-declared type; undeclared leaves get best-effort JSON coercion so untouched
* numbers/booleans survive a form round-trip.
*
* Disabled rows and empty values are omitted — leaving a field empty is how a user
* drops an optional property from the body.
*/
var foldStructuredBodyRows = (rows, schema) => {
	const isDottedNestedRow = buildDottedNestedRowPredicate(schema);
	const result = {};
	for (const row of rows) {
		if (row.isDisabled || !row.name) continue;
		const value = row.value;
		if (typeof value !== "string" || value === "") continue;
		const segments = isDottedNestedRow(row.name, value) ? row.name.split(".") : [row.name];
		const leafSchema = resolveLeafSchema(schema, segments);
		setValueAtPath(result, segments, leafSchema && "type" in leafSchema && leafSchema.type != null ? coerceLeafValueToSchemaType(value, leafSchema) : coerceUntypedValue(value));
	}
	return result;
};
//#endregion
export { foldStructuredBodyRows };

//# sourceMappingURL=fold-structured-body-rows.js.map